export enum StyleTypes {
  primary = 'PRIMARY',
  blue = 'BLUE',
}
